import { render } from "./MfDate.vue?vue&type=template&id=55adc4d3&scoped=true"
import script from "./MfDate.vue?vue&type=script&lang=js"
export * from "./MfDate.vue?vue&type=script&lang=js"

import "./MfDate.vue?vue&type=style&index=0&id=55adc4d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55adc4d3"]])

export default __exports__